'use strict';

/**
 * Иконки для разных типов объектов.
 *
 * @readonly
 * @enum {string} ICONS
 * @since 5.7
 */
window.ICONS = Object.freeze({
  Job: 'job-32',
  Task: 'task-32',
  Notice: 'notice-32',
  ControlJob: 'jobControl-32',
});
